import Fade from '@mui/material/Fade'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import AnimatedBackground from '@components/AnimatedBackground'
import AnimatedIcon from '@components/AnimatedIcon'
import BackgroundCircles from '@components/BackgroundCircles'

export default function ErrorLayout({ hero, title, subtitle, primary, secondary, caption, footer, ...props }) {
  return (
    <Fade in>
      <Stack role="main" sx={styles.page} {...props}>
        <AnimatedBackground />
        <BackgroundCircles />
        {hero}
        <Stack sx={styles.copy}>
          <Typography component="h1" id="error-title" sx={styles.title}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="h6" id="error-subtitle" sx={styles.subtitle}>
              {subtitle}
            </Typography>
          )}
        </Stack>
        <Stack sx={styles.actions}>
          {primary}
          {secondary && <Stack sx={styles.secondary}>{secondary}</Stack>}
        </Stack>
        {footer}
        {caption && (
          <Typography variant="caption" sx={styles.caption}>
            {caption}
          </Typography>
        )}
      </Stack>
    </Fade>
  )
}

export function ErrorHero({ icon }) {
  return (
    <Stack aria-hidden="true">
      <AnimatedIcon icon={icon} />
    </Stack>
  )
}

const styles = {
  page: {
    position: 'relative',
    minHeight: '100dvh',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: { xs: 3, sm: 4 },
    px: 3,
    py: 6,
  },
  copy: {
    alignItems: 'center',
    gap: 1.5,
  },
  title: {
    typography: { xs: 'h3', sm: 'h2' },
    fontWeight: 'fontWeightLight',
    textTransform: 'none',
  },
  subtitle: {
    maxWidth: 480,
    color: 'text.secondary',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    width: '100%',
    maxWidth: 360,
    gap: 1.5,
    '& > .MuiButton-root': { width: '100%' },
  },
  caption: {
    position: 'absolute',
    bottom: 24,
    color: 'text.disabled',
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  secondary: {
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 0.5,
  },
}
